import { inject, observer } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance } from 'mobx-state-tree';
import { ActionCode, Page, TLCode } from '../../common/enums';
import {
  AnchorStore,
  GroupStore,
  ApplicationStore,
  AuthenticationStore,
  BankHolidayDateStore,
  BlackPointStore,
  DutyStore,
  PharmacyDetailedStore,
  PharmacyStore,
  UiStore,
  DutyAssignmentStore,
  UserStore,
  DutyOffRequestStore,
  SystemStatusStore,
  ModalStore,
  MunicipalityStore,
  SecretariatStore,
} from '../../store';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Card, Tab, Tabs } from '@blueprintjs/core';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import PharmacyForm from './PharmacyForm';
import {
  BankHolidayDate,
  BlackPoint,
  DutyAssignment,
  DutyOffRequest,
  User,
  SystemStatus,
  Pharmacy,
} from '../../store/models';
import PharmacyDutiesCalendar from './PharmacyDutiesCalendar';
import PharmacyMapPanel from './PharmacyMapPanel';
import NeighborsPanel from './NeighborsPanel';
import styled from '@emotion/styled';
import { css } from 'emotion';
import PharmacyDutiesList from './PharmacyDutiesList';
import PharmacyDutyRoster from './PharmacyDutyRoster';
import { TranslatedMessage } from '../common/translation';
import moment from 'moment';
import { IconNames } from '@blueprintjs/icons';
import Select from 'react-select';
import MultiCalendarsForComparison from '../common/calendar/MultiCalendarsForComparison';
import { InputGroup } from '@blueprintjs/core';
import DutiesPage from '../Duties';
import { ConfirmationDialog } from '../common/dialog/ConfirmationDialog';
import { MultiCalendarSelectionType } from '../common/calendar/MultiCalendar';
import PharmacyExchangeHistory from './PharmacyExchangeHistory';
import { DutyExchangeItemStore } from '../../store/DutyExchangeItemStore';
import { DutyType } from '../../store/models/DutyType';
import PharmacyComparedData from './PharmacyComparedData';

interface PharmacyPageProps extends RouteComponentProps<{ pharmacyId: string }> {
  ApplicationStore?: Instance<typeof ApplicationStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  UiStore?: Instance<typeof UiStore>;
  BankHolidayDateStore?: Instance<typeof BankHolidayDateStore>;
  BlackPointStore?: Instance<typeof BlackPointStore>;
  DutyAssignmentStore?: Instance<typeof DutyAssignmentStore>;
  DutyOffRequestStore?: Instance<typeof DutyOffRequestStore>;
  DutyStore?: Instance<typeof DutyStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  DutyExchangeItemStore?: Instance<typeof DutyExchangeItemStore>;
  AnchorStore?: Instance<typeof AnchorStore>;
  GroupStore?: Instance<typeof GroupStore>;
  MunicipalityStore?: Instance<typeof MunicipalityStore>;
  SystemStatusStore?: Instance<typeof SystemStatusStore>;
  ModalStore?: Instance<typeof ModalStore>;
  UserStore?: Instance<typeof UserStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  pharmacyList?: Array<Instance<typeof Pharmacy>>;
  getPharmacyById: (id: number) => any;
}

interface PharmacyPageState {
  bankHolidayDates: Array<Instance<typeof BankHolidayDate>>;
  blackPointList: Array<Instance<typeof BlackPoint>>;
  dutyAssignments: Array<Instance<typeof DutyAssignment>>;
  groupDutyAssignments: Array<Instance<typeof DutyAssignment>>;
  dutyOffRequests: Array<Instance<typeof DutyOffRequest>>;
  userForPharmacy: Array<Instance<typeof User>>;
  systemStatusForSecretariat: Array<Instance<typeof SystemStatus>>;
  isLoading: boolean;
  pharmacyId: number;
  secretariatId: number;
  isPharmacy: boolean;
  nextAcceptableBlackpoint?: any;
  dutyAssignmentsOnMap: Array<Instance<typeof DutyAssignment>>;
  systemStatus?: any;
  inputRef?: Instance<typeof Select>;
  selectedTabId?: string;
  nextSelectedTabId?: string;
  selectedPlanningId: string;
  openConfirmationDialog: boolean;
  isDutyCalendarBeingEdited: boolean;
  selectedType?: MultiCalendarSelectionType | undefined;
  selectedYear: number;
  exchangeHistoryIsLoading: boolean;
  exchangeItemHistory: any[];
}

@inject('ApplicationStore')
@inject('AuthenticationStore')
@inject('BankHolidayDateStore')
@inject('BlackPointStore')
@inject('DutyAssignmentStore')
@inject('DutyOffRequestStore')
@inject('DutyStore')
@inject('PharmacyDetailedStore')
@inject('PharmacyStore')
@inject('AnchorStore')
@inject('GroupStore')
@inject('MunicipalityStore')
@inject('UserStore')
@inject('SystemStatusStore')
@inject('UiStore')
@inject('ModalStore')
@inject('SecretariatStore')
@inject('DutyExchangeItemStore')
@observer
class PharmacyPage extends React.Component<PharmacyPageProps & WithTranslateProps, PharmacyPageState> {
  state = {
    bankHolidayDates: [],
    blackPointList: [],
    blackPointList2: [],
    dutyAssignments: [],
    groupDutyAssignments: [],
    dutyOffRequests: [],
    userForPharmacy: [],
    systemStatusForSecretariat: [],
    isLoading: true,
    pharmacyId: 0,
    secretariatId: 0,
    isPharmacy: false,
    dutyAssignmentsOnMap: [],
    nextAcceptableBlackpoint: null,
    systemStatus: null,
    selectedTabId: '',
    nextSelectedTabId: '',
    selectedPlanningId: '',
    openConfirmationDialog: false,
    isDutyCalendarBeingEdited: false,
    selectedType: undefined,
    selectedYear: this.props.UiStore!.pharmacyFirstLineYear,
    exchangeHistoryIsLoading: false,
    exchangeItemHistory: [],
  };

  _isMounted = false;

  private cancelChildChanges?: () => void;

  searchMap = async (criteria: any) => {
    await this.searchDutiesForMap(criteria);
    return this.state.dutyAssignmentsOnMap; // duties;
  };

  async fetchData() {
    const pharmacyIdParam = this.props.match.params.pharmacyId;
    const pharmacyId = Number(pharmacyIdParam);
    const planningId = this.state.selectedPlanningId; //-1;

    const {
      UserStore,
      AuthenticationStore,
      ApplicationStore,
      PharmacyDetailedStore,
      PharmacyStore,
      UiStore,
    } = this.props;
    this._isMounted && this.setState({ isLoading: true, pharmacyId });

    let isPharmacy = false;
    if (
      AuthenticationStore!.userActionCodes.includes(ActionCode.PHARMACY_USER_CODE) &&
      pharmacyId !== AuthenticationStore!.pharmacyId
    ) {
      ApplicationStore!.navigate(Page.Unauthorized);
    } else if (AuthenticationStore!.userActionCodes.includes(ActionCode.PHARMACY_USER_CODE)) {
      isPharmacy = true;
    }

    if (pharmacyId > 0) {
      await PharmacyDetailedStore!.ensureLoaded(pharmacyId);
      UiStore!.setLastSelectedPharmacy(pharmacyId);
      UiStore!.setMultiCalendarFirstPharmacyId(pharmacyId);
      const criteria: any = { role: ActionCode.PHARMACY_USER_CODE.toString() };
      await this.props.SystemStatusStore!.loadList();
      const nextAcceptableBlackpoint = this.props.SystemStatusStore!.dataList.filter(
        (it) => it.subSystem == 'NextAcceptableBlackpoint',
      );
      this._isMounted && this.setState({ nextAcceptableBlackpoint });

      const pharmacy = this.props.PharmacyDetailedStore!.getById(pharmacyId)!;

      const lastPublishedDutySubSystem = this.props.SystemStatusStore!.dataList.find(
        (ss) => ss.subSystem === 'LastPublishedDuty' && ss.secretariatId === pharmacy.secretariatId,
      );
      const lastPublished =
        lastPublishedDutySubSystem !== undefined
          ? moment(lastPublishedDutySubSystem!.status, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : undefined;

      await Promise.all([
        this.searchDuties({
          pharmacyId,
          planningId,
          endDate: isPharmacy && pharmacy.level == 3 ? lastPublished + 'T00:00:00.00' : undefined,
        }),
        this.searchBlackPoints({
          pharmacyId,
        }),
        this.loadDataForCalendar(pharmacyId, pharmacy.secretariatId),
        this.searchHistory(false, new Date().getFullYear() - 1),
      ]).then((responses) => {
        PharmacyStore!.checkListLoaded();
        if (UserStore!.dataList.length === 0) UserStore!.search(criteria);
        this._isMounted &&
          this.setState({
            // @ts-ignore
            userForPharmacy: UserStore!.dataList, //responses[5],
            dutyAssignments:
              isPharmacy && pharmacy.level == 3
                ? responses[0].filter((da) => da.duty.dutyDate.date <= lastPublished + 'T00:00:00.00')
                : responses[0],
            blackPointList: responses[1],
            secretariatId: pharmacy.secretariatId ? pharmacy.secretariatId : 0,
            ...responses[2],
            isPharmacy,
            isLoading: false,
          });
      });
    } else {
      const criteria: any = { role: ActionCode.PHARMACY_USER_CODE.toString() };
      const usersPharmacy = await UserStore!.search(criteria);
      // @ts-ignore
      this._isMounted && this.setState({ userForPharmacy: usersPharmacy, isLoading: false });
    }
  }

  async componentDidMount() {
    this._isMounted = true;
    this.props.AnchorStore!.checkListLoaded();
    this.props.GroupStore!.checkListLoaded();
    this.props.MunicipalityStore!.checkListLoaded();
    this.props.SecretariatStore!.checkListLoaded();
    this.props.SystemStatusStore!.checkListLoaded();
    const nextAcceptableBlackpoint = this.props.SystemStatusStore!.dataList.filter(
      (it) => it.subSystem == 'NextAcceptableBlackpoint',
    );
    this._isMounted && this.setState({ nextAcceptableBlackpoint });

    await this.fetchData();

    this._isMounted && this.setState({ selectedPlanningId: '-1' });
    this._isMounted && this.setState({ selectedTabId: this.state.pharmacyId > 0 ? 'dutyCalendar' : 'details' });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps: PharmacyPageProps, prevState: Readonly<PharmacyPageState>): void {
    if (prevProps.match.params.pharmacyId !== this.props.match.params.pharmacyId) {
      this.fetchData();
    }
    if (this.state.selectedYear !== this.props.UiStore!.pharmacyFirstLineYear) {
      this._isMounted && this.setState({ selectedYear: this.props.UiStore!.pharmacyFirstLineYear });
      if (this.state.selectedTabId === 'groupDutyList') {
        this.onGroupDutyListTabSelect();
      }
    }
  }

  savePharmacy = (data) => {
    this.props.PharmacyDetailedStore!.savePharmacyDetails(data);
  };

  setDutyCalendarEdited = () => this.setState({ isDutyCalendarBeingEdited: true });

  searchBlackPoints = async (criteria: any) => {
    let result;
    await Promise.all([this.props.BlackPointStore!.search(criteria)])
      .catch((e) => console.log(e))
      .then((responses) => (result = responses[0]));

    return result;
  };

  searchHistory = async (
    currentValueOnlyUndownloadedValues: boolean | undefined,
    year: number | undefined = undefined,
  ) => {
    const pharmacyId = this.state.isPharmacy ? this.props.AuthenticationStore!.pharmacyId : this.state.pharmacyId;

    if (!pharmacyId) {
      return;
    }

    const criteria = {
      pharmacyId: pharmacyId,
      onlyFutureDutyExchange: currentValueOnlyUndownloadedValues,
      fromYear: currentValueOnlyUndownloadedValues ? undefined : year,
    };

    this._isMounted && this.setState({ exchangeHistoryIsLoading: true });

    const responses = await Promise.all([
      this.props.DutyExchangeItemStore!.search(criteria as any),
      this.props.DutyStore!.searchForDutyExchangeItem(criteria as any),
    ]);
    //@ts-ignore
    var exchangeItemHistory = this.buildGridData(responses[0]);
    this._isMounted && this.setState({ exchangeItemHistory });
    this._isMounted && this.setState({ exchangeHistoryIsLoading: false });
  };

  buildGridData = (dutyExchangeList: any[]) => {
    return dutyExchangeList.map((elem) => ({
      dutyExchangeItemId: elem.dutyExchangeItemId,
      dutyAssignmentId: elem.dutyAssignmentId,
      recipientId: elem.recipientId,
      date: elem.createdOn,
      sender: elem.sender.apbNumber + ' - ' + elem.sender.name,
      recipient: elem.recipient.apbNumber + ' - ' + elem.recipient.name,
      dutyDate: elem.dutyAssignment.duty ? elem.dutyAssignment.duty.dutyDate.date : '',
      dutyType: elem.dutyAssignment.duty
        ? this.props.translate(this.mapDutyTypeToTLCode(elem.dutyAssignment.duty.dutyType!))
        : '',
      requestedBy: elem.requestorName,
    }));
  };

  mapDutyTypeToTLCode = (dutyType: Instance<typeof DutyType>) => {
    switch (dutyType.type) {
      case 'DAY':
        return TLCode.EXCHANGE_HISTORY_Day;
      case 'NIGHT':
        return TLCode.EXCHANGE_HISTORY_Night;
      default:
        return TLCode.dummy;
    }
  };

  searchDutyOffRequests = async (criteria: any) => {
    let result;
    await Promise.all([this.props.DutyOffRequestStore!.searchDutyOffRequest(criteria)])
      .catch((e) => console.log(e))
      .then((responses) => (result = responses[0]));

    return result;
  };

  searchDuties = async (criteria: any) => {
    const { DutyAssignmentStore, PharmacyStore, DutyStore } = this.props;
    let result;
    await Promise.all([DutyAssignmentStore!.searchAssignment(criteria), DutyStore!.searchForDutyAssignment(criteria)])
      .catch((e) => console.error(e))
      .then((responses) => {
        result = responses[0];
      });

    return result;
  };

  searchDutiesForMap = async (criteria: any) => {
    const { DutyAssignmentStore, PharmacyStore, DutyStore } = this.props;
    await Promise.all([
      DutyAssignmentStore!.searchAssignment(criteria),
      PharmacyStore!.searchForDutyAssignment(criteria),
      DutyStore!.searchForDutyAssignment(criteria),
    ])
      .catch((e) => console.error(e))
      .then((responses) => {
        this._isMounted && this.setState({ dutyAssignmentsOnMap: responses[0] });
      });
  };

  loadDataForCalendar = async (pharmacyId: number, secretariatId: number | undefined) => {
    let result = {};
    const promises = [
      //      this.props.BankHolidayDateStore!.loadList(),
      this.props.DutyOffRequestStore!.searchDutyOffRequest({ pharmacyId }),
    ] as Array<Promise<any>>;
    if (secretariatId != null) {
      const criteriaBP: any = { secretariatId };
      promises.push(this.props.SystemStatusStore!.search(criteriaBP));
    } else {
      const criteriaBP: any = { secretariatId: 1 };
      promises.push(this.props.SystemStatusStore!.search(criteriaBP));
    }
    if (this.props.BankHolidayDateStore!.dataList.length === 0) {
      promises.push(this.props.BankHolidayDateStore!.loadList());
    }

    await Promise.all(promises)
      .catch((e) => console.log(e))
      .then((responses) => {
        if (responses) {
          result = Object.assign(result, {
            bankHolidayDates: this.props.BankHolidayDateStore!.dataList,
            dutyOffRequests: responses[0],
          });
          if (responses.length >= 2) result = Object.assign(result, { systemStatusForSecretariat: responses[1] });
        }
      });

    return result;
  };

  saveCalendarChange = async (data: any) => {
    await this.props.PharmacyDetailedStore!.saveCalendarChange(data);
    this.searchBlackPoints({ pharmacyId: this.state.pharmacyId }).then(
      (resp) => this._isMounted && this.setState({ blackPointList: resp }),
    );
    this.searchDutyOffRequests({ pharmacyId: this.state.pharmacyId }).then(
      (resp) => this._isMounted && this.setState({ dutyOffRequests: resp }),
    );
    this.searchDuties({ pharmacyId: this.state.pharmacyId }).then((resp) => {
      this._isMounted && this.setState({ dutyAssignments: resp });
      if (this.cancelChildChanges) {
        this.cancelChildChanges!();
      }
    });
    const dutiesOff: any = await this.props.DutyOffRequestStore!.searchDutyOffRequest({
      pharmacyId: this.state.pharmacyId,
    });
    this._isMounted && this.setState({ dutyOffRequests: dutiesOff });
    this._isMounted && this.setState({ isDutyCalendarBeingEdited: false });
  };

  onSelectedPharmacyChanged2 = (selectedOption: any) => {
    this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${selectedOption.value}`);
  };

  navigate = (data: any) => {
    const pharmacyId = this.state.pharmacyId;
    let pharmacyIdToNavigateTo: number | undefined = undefined;
    if (data === 'NEXT') {
      pharmacyIdToNavigateTo = this.props.UiStore!.getNextNavigationPharmacy(pharmacyId);
    } else if (data === 'PREVIOUS') {
      pharmacyIdToNavigateTo = this.props.UiStore!.getPreviousNavigationPharmacy(pharmacyId);
    } else {
      return;
    }
    if (pharmacyIdToNavigateTo !== undefined)
      this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${pharmacyIdToNavigateTo}`);
  };

  generateDutyReport = async (criteria: any, language: string) => {
    this._isMounted && this.setState({ isLoading: true });
    await Promise.all([
      this.props.DutyAssignmentStore!.dutyRosterReport(
        criteria,
        language,
        this.restoreLoadingStatus,
        this.restoreLoadingStatus,
      ),
    ])
      .catch(console.error)
      .then((responses) => {});
  };

  restoreLoadingStatus = () => {
    this._isMounted && this.setState({ isLoading: false });
  };

  onConfirmTabChangeDutyCalendar = () => {
    this.setState({ openConfirmationDialog: false });
    this.props.UiStore!.setPharmacyPageActiveTab(this.state.nextSelectedTabId.toString());
    this.setState({
      selectedTabId: this.state.nextSelectedTabId,
      isDutyCalendarBeingEdited: false,
    });
  };

  onTypeChange = (type: MultiCalendarSelectionType) => {
    if (this.state.selectedType !== type) {
      this.setState({ selectedType: type });
    }
  };

  onCalendarMove = async (fly: number, sly: number) => {
    const { pharmacyId, isPharmacy } = this.state;
    const pharmacy = this.props.PharmacyDetailedStore!.getById(pharmacyId)!;
    const lastPublishedDutySubSystem = this.props.SystemStatusStore!.dataList.find(
      (ss) => ss.subSystem === 'LastPublishedDuty' && ss.secretariatId === pharmacy.secretariatId,
    );
    const lastPublished =
      lastPublishedDutySubSystem !== undefined
        ? moment(lastPublishedDutySubSystem!.status, 'DD/MM/YYYY').format('YYYY-MM-DD')
        : undefined;

    const planningId = -1;
    await Promise.all([
      this.searchDuties({
        pharmacyId,
        planningId,
        endDate: isPharmacy && pharmacy.level == 3 ? lastPublished + 'T00:00:00.00' : undefined,
      }),
      this.searchBlackPoints({
        pharmacyId,
      }),
    ]).then((responses) => {
      this._isMounted &&
        this.setState({
          dutyAssignments:
            isPharmacy && pharmacy.level == 3
              ? responses[0].filter((da) => da.duty.dutyDate.date <= lastPublished + 'T00:00:00.00')
              : responses[0],
          blackPointList: responses[1],
        });
    });
    this.props.UiStore!.setPharmacyCalendarYear(fly);
    if (this.state.selectedYear !== fly) {
      this.setState({ selectedYear: fly });
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  onGroupDutyListTabSelect = async () => {
    if (
      this.state.groupDutyAssignments.length == 0 ||
      this.state.groupDutyAssignments.find(
        (d: Instance<typeof DutyAssignment>) =>
          moment(d.duty!.dutyDate.date).year() === this.props.UiStore!.pharmacyFirstLineYear,
      ) === undefined
    ) {
      const pharmacyIdParam = this.props.match.params.pharmacyId;
      const pharmacyId = Number(pharmacyIdParam);
      const planningId = this.state.selectedPlanningId; //-1;

      const {
        UserStore,
        AuthenticationStore,
        ApplicationStore,
        PharmacyDetailedStore,
        PharmacyStore,
        UiStore,
      } = this.props;
      this._isMounted && this.setState({ isLoading: true, pharmacyId });

      let isPharmacy = false;
      if (
        AuthenticationStore!.userActionCodes.includes(ActionCode.PHARMACY_USER_CODE) &&
        pharmacyId !== AuthenticationStore!.pharmacyId
      ) {
        ApplicationStore!.navigate(Page.Unauthorized);
      } else if (AuthenticationStore!.userActionCodes.includes(ActionCode.PHARMACY_USER_CODE)) {
        isPharmacy = true;
      }

      if (pharmacyId > 0) {
        await PharmacyDetailedStore!.ensureLoaded(pharmacyId);
        const pharmacy = PharmacyDetailedStore!.getById(pharmacyId)!;
        UiStore!.setLastSelectedPharmacy(pharmacyId);
        UiStore!.setMultiCalendarFirstPharmacyId(pharmacyId);
        const criteria: any = { role: ActionCode.PHARMACY_USER_CODE.toString() };
        await this.props.SystemStatusStore!.loadList();
        const nextAcceptableBlackpoint = this.props.SystemStatusStore!.dataList.filter(
          (it) => it.subSystem == 'NextAcceptableBlackpoint',
        );
        this._isMounted && this.setState({ nextAcceptableBlackpoint });

        const lastPublishedDutySubSystem = this.props.SystemStatusStore!.dataList.find(
          (ss) => ss.subSystem === 'LastPublishedDuty' && ss.secretariatId === pharmacy.secretariatId,
        );
        const lastPublished =
          lastPublishedDutySubSystem !== undefined
            ? moment(lastPublishedDutySubSystem!.status, 'DD/MM/YYYY').format('YYYY-MM-DD')
            : undefined;

        const firstDayOfSelectedYear =
          moment()
            .year(this.props.UiStore!.pharmacyFirstLineYear)
            .startOf('year')
            .format('YYYY-MM-DD') + 'T00:00:00.00';
        const lastDayOfSelectedYear = moment()
          .year(this.props.UiStore!.pharmacyFirstLineYear)
          .endOf('year');

        await Promise.all([
          this.searchDuties({
            pharmacyId,
            planningId,
            groupId: pharmacy.groupId,
            includeGroupDuties: true,
            startDate: firstDayOfSelectedYear,
            endDate:
              isPharmacy && pharmacy.level == 3
                ? moment.min(moment(lastPublished + 'T00:00:00.00'), lastDayOfSelectedYear).format('YYYY-MM-DD') +
                  'T00:00:00.00'
                : lastDayOfSelectedYear.format('YYYY-MM-DD') + 'T00:00:00.00',
          }),
        ]).then((responses) => {
          PharmacyStore!.checkListLoaded();
          if (UserStore!.dataList.length === 0) UserStore!.search(criteria);
          this._isMounted &&
            this.setState({
              groupDutyAssignments:
                isPharmacy && pharmacy.level == 3
                  ? responses[0].filter((da) => da.duty.dutyDate.date <= lastPublished + 'T00:00:00.00')
                  : responses[0],
              isPharmacy,
              isLoading: false,
            });
        });
      } else {
        const criteria: any = { role: ActionCode.PHARMACY_USER_CODE.toString() };
        const usersPharmacy = await UserStore!.search(criteria);
        // @ts-ignore
        this._isMounted && this.setState({ userForPharmacy: usersPharmacy, isLoading: false });
      }
    }
  };

  render() {
    const {
      translate,
      PharmacyDetailedStore,
      PharmacyStore,
      GroupStore,
      AnchorStore,
      MunicipalityStore,
      AuthenticationStore,
      ApplicationStore,
      ModalStore,
      SecretariatStore,
    } = this.props;
    const { systemStatusForSecretariat, isPharmacy } = this.state;

    const { pharmacyId } = this.state;
    const pharmacyDetails = PharmacyDetailedStore!.getByIdOrNew(pharmacyId);

    const pharmacyList = PharmacyStore!.dataList;

    const selectedOption = '';

    const result = (
      <MainSectionLayout
        isLoading={this.state.isLoading}
        title={TLCode.PHARMACY_Title}
        renderRightComponent={
          !isPharmacy
            ? () => (
                <DivLine>
                  <Button onClick={this.goBack}>
                    <TranslatedMessage id={TLCode.Back} />
                  </Button>
                  <Button
                    icon={IconNames.CHEVRON_LEFT}
                    large={true}
                    style={{ marginLeft: '5px' }}
                    onClick={() => this.navigate('PREVIOUS')}
                  />
                  <DivColumnExt>
                    <Select
                      value={selectedOption}
                      onChange={this.onSelectedPharmacyChanged2}
                      options={pharmacyList.map((elem) => {
                        return {
                          value: elem.pharmacyId,
                          label:
                            '(' +
                            (elem.level +
                              '- group ' +
                              (elem.groupId === undefined
                                ? ''
                                : this.props.GroupStore!.dataList.find((g) => g.groupId === elem.groupId)!.name)) +
                            ') - ' +
                            elem.apbNumber +
                            ' ' +
                            elem.name +
                            ' @ ' +
                            elem.city,
                        };
                      })}
                    />
                  </DivColumnExt>
                  <Button
                    icon={IconNames.CHEVRON_RIGHT}
                    large={true}
                    style={{ height: '30px', marginRight: '5px' }}
                    onClick={() => this.navigate('NEXT')}
                  />
                  <InputGroup
                    placeholder="PlanningId"
                    value={this.state.selectedPlanningId}
                    onChange={(e) => {
                      this.setState({ selectedPlanningId: e.target.value });
                    }}
                  />
                  <Button
                    icon={IconNames.SEARCH}
                    large={true}
                    style={{ height: '30px', marginRight: '5px' }}
                    onClick={() => this.fetchData()}
                  />
                  <Button
                    icon={IconNames.RESET}
                    large={true}
                    style={{ height: '30px', marginRight: '5px' }}
                    onClick={() => this.setState({ selectedPlanningId: '-1' })}
                  />
                </DivLine>
              )
            : undefined
        }
      >
        <Container>
          <Card className={CardStyle.toString()}>
            <ConfirmationDialog
              isOpen={this.state.openConfirmationDialog}
              onCancel={() => this.setState({ openConfirmationDialog: false })}
              onContinue={this.onConfirmTabChangeDutyCalendar}
              title={translate(TLCode.PHARMACY_DUTY_CALENDAR_ConfirmationDialog_Title)}
              message={translate(TLCode.PHARMACY_DUTY_CALENDAR_ConfirmationDialog_Message)}
              confirmText={translate(TLCode.PHARMACY_DUTY_CALENDAR_ConfirmationDialog_Confirm)}
              cancelText={translate(TLCode.PHARMACY_DUTY_CALENDAR_ConfirmationDialog_Cancel)}
            />
            <Tabs
              renderActiveTabPanelOnly={true}
              id="main"
              defaultSelectedTabId={pharmacyId > 0 ? 'dutyCalendar' : 'details'}
              selectedTabId={this.state.selectedTabId}
              onChange={(newTabId: string, prevTabId: string) => {
                if (prevTabId === 'dutyCalendar' && this.state.isDutyCalendarBeingEdited) {
                  this.setState({ openConfirmationDialog: true, nextSelectedTabId: newTabId });
                } else {
                  this.props.UiStore!.setPharmacyPageActiveTab(newTabId.toString());
                  this.setState({ selectedTabId: newTabId });
                  if (newTabId === 'groupDutyList') {
                    this.onGroupDutyListTabSelect();
                  }
                }
              }}
            >
              <Tab
                id="details"
                className={tabDetails}
                title={
                  <span style={{ backgroundColor: '#ccf99f' }}>
                    <TranslatedMessage id={TLCode.PHARMACY_Details} />
                  </span>
                }
                panel={
                  <PharmacyForm
                    pharmacy={pharmacyDetails}
                    save={this.savePharmacy}
                    groupList={GroupStore!.dataList}
                    anchorList={AnchorStore!.dataList}
                    municipalityList={MunicipalityStore!.dataList}
                    userList={this.state.userForPharmacy}
                    secretariatList={SecretariatStore!.dataList}
                    userRoles={AuthenticationStore!.userActionCodes}
                  />
                }
              />
              <Tab
                id="dutyCalendar"
                title={
                  <span style={{ backgroundColor: '#9fe1f9' }}>
                    <TranslatedMessage id={TLCode.PHARMACY_DutyCalendar} />
                  </span>
                }
                disabled={pharmacyId === -1}
                panel={
                  <PharmacyDutiesCalendar
                    bindCancelMethod={(fn) => {
                      this.cancelChildChanges = fn;
                    }}
                    bankHolidayDateList={this.state.bankHolidayDates}
                    blackPointList={this.state.blackPointList}
                    dutyAssignments={this.state.dutyAssignments}
                    dutyOffRequests={this.state.dutyOffRequests}
                    pharmacyDetails={pharmacyDetails}
                    saveCalendarChange={this.saveCalendarChange}
                    pharmacyId={this.state.pharmacyId}
                    systemStatus={systemStatusForSecretariat}
                    isSecretariat={
                      this.props.AuthenticationStore!.isSecretariat ||
                      this.props.AuthenticationStore!.isAdmin ||
                      this.props.AuthenticationStore!.isSuperAdmin
                    }
                    inMultiCalendar={false}
                    ModalStore={ModalStore}
                    userList={this.state.userForPharmacy}
                    separateToolbox={true}
                    onModification={this.setDutyCalendarEdited}
                    onTypeChange={this.onTypeChange}
                    selectedType={this.state.selectedType}
                    fly={this.state.selectedYear}
                    onCalendarMove={this.onCalendarMove}
                    exchangeHistoryList={this.state.exchangeItemHistory}
                  />
                }
              />
              <Tab
                id="dutyList"
                title={
                  <span style={{ backgroundColor: '#f7e08f' }}>
                    <TranslatedMessage id={TLCode.PHARMACY_DutyList} />
                  </span>
                }
                disabled={pharmacyId === -1}
                panel={
                  <PharmacyDutiesList
                    duties={this.state.dutyAssignments}
                    pharmacyDetails={pharmacyDetails}
                    groupMode={false}
                  />
                }
              />
              <Tab
                id="groupDutyList"
                title={
                  <span style={{ backgroundColor: '#ff78fb' }}>
                    <TranslatedMessage id={TLCode.PHARMACY_GroupDutyList} />
                  </span>
                }
                disabled={pharmacyId === -1}
                panel={
                  <PharmacyDutiesList
                    duties={this.state.groupDutyAssignments}
                    pharmacyDetails={pharmacyDetails}
                    groupMode={true}
                    onYearChange={this.onGroupDutyListTabSelect}
                  />
                }
              />
              <Tab
                id="dutyRoster"
                title={
                  <span style={{ backgroundColor: '#845df7' }}>
                    <TranslatedMessage id={TLCode.PHARMACY_DutyRoster} />
                  </span>
                }
                disabled={pharmacyId === -1}
                panel={
                  <PharmacyDutyRoster
                    getDutyRosterReport={this.generateDutyReport}
                    pharmacyId={pharmacyId}
                    pharmacyDetails={pharmacyDetails}
                    systemStatus={systemStatusForSecretariat}
                  />
                }
              />
              <Tab
                id="duties"
                title={
                  <span style={{ backgroundColor: '#16e3f9' }}>
                    <TranslatedMessage id={TLCode.DutyPage} />
                  </span>
                }
                disabled={pharmacyId === -1}
                panel={pharmacyId > 0 ? <DutiesPage /> : <div />}
              />
              <Tab
                id="map"
                title={
                  <span style={{ backgroundColor: '#16f97c' }}>
                    <TranslatedMessage id={TLCode.PHARMACY_Map} />
                  </span>
                } // carte du voisinage
                disabled={pharmacyId === -1}
                panel={
                  pharmacyId > 0 ? (
                    <PharmacyMapPanel
                      pharmacyDetails={pharmacyDetails}
                      PharmacyDetailedStore={PharmacyDetailedStore!}
                      PharmacyStore={PharmacyStore!}
                      GroupStore={GroupStore!}
                    />
                  ) : (
                    <div />
                  )
                }
              />
              <Tab
                id="neighborhood"
                title={
                  <span style={{ backgroundColor: '#f7b774' }}>
                    <TranslatedMessage id={TLCode.PHARMACY_Neighborhood} />
                  </span>
                } // liste du voisinage
                disabled={pharmacyId === -1}
                panel={
                  pharmacyId > 0 ? (
                    <NeighborsPanel
                      pharmacyDetails={pharmacyDetails}
                      getPharmacy={PharmacyDetailedStore!.getById}
                      ApplicationStore={ApplicationStore}
                      isPharmacy={isPharmacy}
                    />
                  ) : (
                    <div />
                  )
                }
              />
              {!this.state.isPharmacy && (
                <Tab
                  id="calendar comparison"
                  title={
                    <span style={{ backgroundColor: '#daf736' }}>
                      <TranslatedMessage id={TLCode.PHARMACY_CalendarComparison} />
                    </span>
                  }
                  disabled={pharmacyId === -1}
                  panel={
                    pharmacyId > 0 ? (
                      <MultiCalendarsForComparison
                        startingPharmacy={pharmacyId}
                        onFirstPharmacyIdChanged={this.props.UiStore!.setMultiCalendarFirstPharmacyId}
                        onSecondPharmacyIdChanged={this.props.UiStore!.setMultiCalendarSecondPharmacyId}
                      />
                    ) : (
                      <div />
                    )
                  }
                />
              )}

              <Tab
                id="pharmacyHistory"
                title={
                  <span style={{ backgroundColor: '#ff78a0ff' }}>
                    <TranslatedMessage id={TLCode.PHARMACY_History} />
                  </span>
                } // liste du voisinage
                disabled={pharmacyId === -1}
                panel={
                  pharmacyId > 0 ? (
                    <PharmacyExchangeHistory
                      exchangeHistoryList={this.state.exchangeItemHistory}
                      pharmacy={pharmacyDetails}
                    />
                  ) : (
                    <div />
                  )
                }
              />

              {!this.state.isPharmacy && (
                <Tab
                  id="geodata"
                  title={
                    <span style={{ backgroundColor: '#ff78a0ff' }}>
                    <TranslatedMessage id={TLCode.PHARMACY_History} />
                  </span>
                  }
                                  panel={
                  pharmacyId > 0 ? (
                    <PharmacyComparedData
                      exchangeHistoryList={this.state.exchangeItemHistory}
                      pharmacy={pharmacyDetails}
                    />
                  ) : (
                    <div />
                  )
                }
                />
              )}
            </Tabs>
          </Card>
        </Container>
      </MainSectionLayout>
    );

    return result;
  }
}

export default withTranslate(PharmacyPage);

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumnExt = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 400px;
`;

const CardStyle = css({
  height: '100%',
  '& .bp3-tabs': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  '& .bp3-tab-panel': {
    flex: 1,
  },
  '& .ag-theme-balham': {
    width: '100%',
  },
});

const tabDetails = css`
  .bp3-tab : {
    background-color: #ffeb3b !important;
  }
`;
